<!-- Responsibility: Implement raw html behavior for the ui/components surface.
Scope: Owns ui/components concerns only; cross-surface orchestration is excluded. -->
<raw-html>
  <script>
    import { formatProse } from '../helpers/format-prose.js'

    export default {
      getContent() {
        const raw = this.props.content ?? this.props.text ?? ''
        if (this.props.mode === 'prose') return formatProse(String(raw))
        return String(raw)
      },

      setHTML() {
        if (this.root) {
          this.root.innerHTML = this.getContent()
          if (this.props.class) {
            this.root.className = this.props.class
          }
        }
      },
      onMounted() { this.setHTML() },
      onUpdated() { this.setHTML() }
    }
  </script>
</raw-html>
